const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

function getToken() {
  return localStorage.getItem('wsa_token');
}

export function setSession(token, user) {
  localStorage.setItem('wsa_token', token);
  localStorage.setItem('wsa_user', JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem('wsa_token');
  localStorage.removeItem('wsa_user');
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('wsa_user'));
  } catch {
    return null;
  }
}

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(`${API_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    ...options
  });
  if (res.status === 401) {
    clearSession();
    window.location.href = '/admin/login';
    throw new Error('Sesioni ka skaduar.');
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Gabim ${res.status}`);
  }
  return res.json();
}

export const api = {
  // Auth
  login: (email, password) => request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  me: () => request('/auth/me'),
  updateMe: (data) => request('/auth/me', { method: 'PUT', body: JSON.stringify(data) }),
  changePassword: (data) => request('/auth/password', { method: 'PUT', body: JSON.stringify(data) }),

  // Admin (menaxhimi i klienteve)
  getClients: () => request('/admin/clients'),
  createClient: (data) => request('/admin/clients', { method: 'POST', body: JSON.stringify(data) }),
  updateClient: (id, data) => request(`/admin/clients/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteClient: (id) => request(`/admin/clients/${id}`, { method: 'DELETE' }),

  // Tavolinat (te klientit te kycur)
  getTables: () => request('/tables'),
  createTable: (data) => request('/tables', { method: 'POST', body: JSON.stringify(data) }),
  updateTable: (id, data) => request(`/tables/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteTable: (id) => request(`/tables/${id}`, { method: 'DELETE' }),

  // Mysafiret (te klientit te kycur)
  getGuests: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/guests${qs ? `?${qs}` : ''}`);
  },
  createGuest: (data) => request('/guests', { method: 'POST', body: JSON.stringify(data) }),
  updateGuest: (id, data) => request(`/guests/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteGuest: (id) => request(`/guests/${id}`, { method: 'DELETE' }),

  // Publike (faqja e mysafireve, pa auth)
  lookupPublic: (slug, name) => request(`/public/lookup/${slug}?name=${encodeURIComponent(name)}`),
  getEventPublic: (slug) => request(`/public/event/${slug}`),

  // QR / PDF (kerkojne auth; hapen si link direkt prandaj token si query param)
  pdfUrl: () => `${API_URL}/pdf?token=${getToken()}`,
  qrUrl: () => `${API_URL}/qrcode?token=${getToken()}`,
  qrLink: () => request('/qrcode/link')
};
